module.exports = __webpack_public_path__ + "img/chris-ewer.b04ddf09.png";